import { serverUrl, getheader, postMethodByCallBack, getMethodByCallBack, cacheTypes, postMethodByDispatcher, setErrorDialog, getMethodByDispatcher } from "../../../store/api/CommonFunctions";
// export function checkCardStatus(data, fn){
//     var token = localStorage.getItem('token');
//     return dispatch =>{
//         dispatch({
//             type:"Loading",
//             data:true
//         })
//         fetch(serverUrl+"api/GuarantyAPI/GetGuarantyStatusData/?SerialNumber="+data.SerialNumber+"&GuarantyCode="+data.CardNo,{
//             headers:getheader(),
//             method:"GET",
//             cache:"default"
//         }).then(res=>res.json()).then(res=>{
//             dispatch({
//                 type:"Loading",
//                 data:false
//             })
//             fn();
//             return dispatch({
//                 type:"GET_CARD_STATUS",
//                 data:res
//             })
//         }).catch(err=>err=>console.error('err',err));
//     }
// }
export function updateGuarantee(card) {
  let msg = ""
  if (!card.GuaranteeStartDate || card.GuaranteeStartDate === "") {
    msg = "تاریخ شروع گارانتی وارد نشده است";
  }
  if (!card.GuaranteeEndDate || card.GuaranteeEndDate === "") {
    msg = "تاریخ پایان گارانتی وارد نشده است";
  }

  return dispatch => {
    if (msg !== "") {
      setErrorDialog(dispatch, msg, "ثبت کارت گارانتی")
      return;
    }
    dispatch(
      {
        type: "LOADING",
        data: true
      }
    )
    fetch(serverUrl + `api/GuarantyAPI/UpdateCardFromService`, {
      headers: getheader(),
      body: JSON.stringify(card),
      method: "POST",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        dispatch(
          {
            type: "LOADING",
            data: false
          }
        )
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "ثبت اطلاعات گارانتی");
        }
        else {
          setErrorDialog(dispatch, "Success", "ثبت اطلاعات گارانتی");
        }
      }).catch(e => { console.log("[UpdateGuarantee]", e) });
  }
}
export function getActiveUnusedGuaranteeCards(cardNo, serialNumber, skip, take) {

  return dispatch => {
    if (!serialNumber && !cardNo) {
      alert("هیچکدام از فیلدهای جستجو پر نشده است");
      return dispatch({
        type: "GET_ACTIVE_UNUSED_CARDS",
        data: []
      });
    }
    dispatch({
      type: "GET_ACTIVE_UNUSED_CARDS",
      data: "PENDING"
    });
    fetch(serverUrl + `api/GuarantyAPI/GetActiveUnusedCard?serialNumber=${serialNumber ?? -1}&cardNo=${cardNo ?? -1}&skip=${skip ?? 0}&take=${take ?? 0}`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (!res || res.status === "404" || res.status === "400") {
          alert("اشکال در انجام عملیات");
          dispatch({
            type: "GET_ACTIVE_UNUSED_CARDS",
            data: []
          });
          return;
        }
        if (res && !res.status && res === "Error") {
          alert("اشکال در ارتباط با سرور");
          dispatch({
            type: "GET_ACTIVE_UNUSED_CARDS",
            data: []
          });
          return;
        }
        dispatch({
          type: "GET_ACTIVE_UNUSED_CARDS",
          data: res
        })
      }

      ).catch(e => {
        dispatch({
          type: "GET_ACTIVE_UNUSED_CARDS",
          data: "PENDING"
        });
        console.log("[GET_ACTIVE_UNUSED_CARDS]", e)
      });
  }
}
export function checkCardStatus(serial, cardNo, onGetResult) {
  getMethodByCallBack(`api/GuarantyAPI/GetGuarantyStatusData/?SerialNumber=${serial ?? ""}&GuarantyCode=${cardNo ?? ""}`, cacheTypes.NoCache, onGetResult, "GetGuarantyStatusData");
}
export async function activeCard(data, onActive) {
  postMethodByCallBack(`api/GuarantyAPI/ActiveCard`, data, onActive, "ActiveCard");
}
export function saveCards(data, saveService, storageID, onPostData) {
  postMethodByCallBack(`api/GuarantyAPI/SaveCards?saveService=${saveService}&storageID=${storageID}`, data, onPostData, "SaveCards");
}
export function deleteCard(id, onDelete) {
  getMethodByCallBack(`api/GuarantyAPI/DeleteCard?id=${id}`, cacheTypes.NoCache, onDelete, "DeleteCard");
}
export function deleteCards(ids, onDelete) {
  postMethodByCallBack(`api/GuarantyAPI/DeleteCards`, ids, onDelete, "DeleteCards");
}
export function updateCardsAgencyID(ids, agencyID, onUpdate) {
  postMethodByCallBack(`api/GuarantyAPI/UpdateCardsAgencyID?agencyID=${agencyID}`, ids, onUpdate, "UpdateCardsAgencyID");
}
export function saveSubCards(data, onSave) {
  postMethodByCallBack(`api/GuarantyAPI/SaveSubCards`, data, onSave, "SaveSubCards");
}
export function addOrUpdateSubProduct(data, onPost) {
  postMethodByCallBack(`api/GuarantyAPI/AddOrUpdateSubProduct`, data, onPost, "addOrUpdateSubProduct");
}
export function getCardSubProducts(cardID, onGet) {
  getMethodByCallBack(`api/GuarantyAPI/GetCardSubProducts?cardID=${cardID}`, cacheTypes.NoCache, onGet, "GetCardSubProducts");
}
export function getCardSubProductsWithSerial(mainSerial, cardNo, onGet) {
  getMethodByCallBack(`api/GuarantyAPI/GetCardSubProducts?mainSerial=${mainSerial}&cardNo=${cardNo}`, cacheTypes.NoCache, onGet, "GetCardSubProducts");
}
export function swapSubProduct(data, onSwapDone) {
  postMethodByCallBack(`api/GuarantyAPI/SwapSubProduct`, data, onSwapDone, "SwapSubProduct");
}
export function deleteSubProduct(id, onDelete) {
  getMethodByCallBack(`api/GuarantyAPI/DeleteSubProduct?id=${id}`, cacheTypes.NoCache, onDelete, "DeleteSubProduct");
}
export function getAllGuaranteeHolders(type, onGetData) {
  postMethodByCallBack("api/GuarantyHolderAPI/GetAllProductHolder", type, onGetData, "GetAllProductHolder");
}
export function searchHolders(isActive, holderType, onGetData) {
  getMethodByCallBack(`api/GuarantyHolderAPI/SearchHolders?isActive=${isActive ?? ""}&holderType=${holderType ?? ""}`, cacheTypes.NoCache, onGetData, "SearchHolders");
}
export function addEditHolder(data, onAddEdit) {
  postMethodByCallBack("api/GuarantyHolderAPI/AddEditHolder", data, onAddEdit, "AddEditHolder");
}
export function deleteHolder(id, onDelete) {
  postMethodByCallBack("api/GuarantyHolderAPI/DeleteHolder", id, onDelete, "DeleteHolder");
}
export function searchCards(data) {
  return dispatch => {
    dispatch({
      type: "GCARDS_FILTERS",
      data: data
    });
    dispatch(postMethodByDispatcher("api/GuarantyAPI/SearchCards", data, "GCARDS_SEARCH_LIST"));
  }
}
export function getAssignedCardsList(data) {
  data.AssignedToAgency = true;
  return dispatch => {
    dispatch({
      type: "ASSIGNED_CARDS_FILTERS",
      data: data
    });
    dispatch(postMethodByDispatcher("api/GuarantyAPI/SearchCards", data, "GCARDS_ASSIGNED_LIST"));
  }
}
export function addEditCard(data, storageID, onAddEdit) {
  postMethodByCallBack(`api/GuarantyAPI/AddEditCard?storageID=${storageID}`, data, onAddEdit, "AddEditCard");
}
export function swapSerial(data, onSwap) {
  postMethodByCallBack("api/GuarantyAPI/SwapSerial", data, onSwap, "SwapSerial");
}
/**
 * 
 * @param {int} serviceID 
 * @param {function} onRemove 
 */
export function removeSwappedSerial(serviceID, onRemove) {
  getMethodByCallBack(`api/GuarantyAPI/RemoveSwappedSerial?serviceID=${serviceID}`, cacheTypes.NoCache, onRemove, "RemoveSwappedSerial");
}
export function getSerialListForSwap(serialNumber, onGet) {
  getMethodByCallBack(`api/GuarantyAPI/GetSerialListForSwap?serialNumber=${serialNumber}`, cacheTypes.NoCache, onGet, "GetSerialListForSwap");
}
export function getFixableSerialsReport(data) {
  return dispatch => {
    dispatch(postMethodByDispatcher("api/GuarantyAPI/getSwappedSerialsReport", data, "FIXABLE_SERIALS", " سریال های در دست تعمیر"));
  }
}
export function fixDamagedProduct(id, onFix) {
  getMethodByCallBack(`api/GuarantyAPI/FixDamagedProduct?id=${id}`, cacheTypes.NoCache, onFix, "FixDamagedProduct");
}
export function getSwappedFromInfo(productID, productSerial, onGet) {
  getMethodByCallBack(`api/GuarantyAPI/GetSwappedFromInfo?productID=${productID}&productSerial=${productSerial}`, cacheTypes.NoCache, onGet, "GetSwappedFromInfo");
}